import apiService from "@/services/apiService";
import ImportUserJobsDialog from "@/components/online/admin/dialogs/ImportUserJobsDialog.vue"
import authTokenService from "@/services/authTokenService";

export default {
    components: {
        ImportUserJobsDialog,
    },

    props: {
        refreshList: {
            defaul: false,
        }
    },

    watch: {
        "$i18n.locale": function () {
            this.headers = [
                {
                    title: 'ID',
                    align: 'start',
                    sortable: true,
                    key: 'id',
                },
                { title: this.$t('datatable.header["Nom de la fonction"]'), key: 'label' },
                { title: this.$t('datatable.header["Secteur d\'activité"]'), key: 'sector' },
                { title: this.$t('datatable.header["Créer le"]'), key: 'createdAt' },
                { title: this.$t('datatable.header["Actions"]'), key: 'actions', sortable: false },
            ];

            this.availableSectors = [
                { label: this.$t('admin["Automobile"]'), value: 0 },
                { label: this.$t('admin["Sante"]'), value: 1 },
                { label: this.$t('admin["Public"]'), value: 2 }
            ];
        },
        search(val) {
            if (val != null && val.trim() != "") {
                this.$router.push({ name: this.$route.name, query: { search: val } })
            } else {
                this.$router.push({ name: this.$route.name })
            }
        },
        refreshList(val) {
            if (val) {
                this.retrieveData();
            }
        },
    },

    data() {
        return {
            loading: false,
            dialogImport: false,

            userJobs: [],
            search: this.$route.query.search ?? null,
            availableSectors: [
                { label: this.$t('admin["Automobile"]'), value: 0 },
                { label: this.$t('admin["Sante"]'), value: 1 },
                { label: this.$t('admin["Public"]'), value: 2 }
            ],

            headers: [
                {
                    title: 'ID',
                    align: 'start',
                    sortable: true,
                    key: 'id',
                },
                { title: this.$t('datatable.header["Nom de la fonction"]'), key: 'label' },
                { title: this.$t('datatable.header["Secteur d\'activité"]'), key: 'sector' },
                { title: this.$t('datatable.header["Créer le"]'), key: 'createdAt' },
                { title: this.$t('datatable.header["Actions"]'), key: 'actions', sortable: false },
            ],
            btns: [
                { label: 'Importer', icon: 'mdi-inbox-arrow-down', type: 'import', value: true },
                { label: 'Nouvelle fonction', icon: 'mdi-plus', type: 'route', value: 'jobsManagementNew' },
            ]
        };
    },

    created() {
        if (!authTokenService.getToken()) return;
        this.retrieveData();
    },

    mounted() { },

    methods: {
        actionHandler(type, value) {
            switch (type) {
                case "route":
                    if (value == '') return;
                    this.$router.push({ name: value })
                    break;
                case "import":
                    this.dialogImport = value
                    break;
                default:
                    break;
            }
        },

        editItem(item) {
            this.$router.push({ name: "jobsManagementDetail", params: { id: item.id } })
        },

        async retrieveData() {
            this.loading = true;
            try {
                const request = await apiService.get(`/jobs`);
                const response = await request.json();
                if (!request.ok) throw new Error(response.message);
                response.data.forEach(el => {
                    el.sector = this.availableSectors.find(element => element.value == el.sector)['label']
                })
                this.userJobs = response.data;
                this.$emit('stopRefresh');
            } catch (error) {
                this.userJobs = [];
            } finally {
                this.loading = false;
            }
        },
    },
};